import { Filter } from "iconoir-react";
import MainLayout from "../layouts/MainLayout";
import { memo, useState } from "react";
import Message from "../components/common/Message";
import { inject, observer } from "mobx-react";
import { useTheme } from "@mui/material";
import { InternalDocumentOutgoing } from "../modules/InternalDocumentOutgoing";
import DocumentPage from "./DocumentPage";

const InternalDocumentOutoingPage = () => {
  const [message, setMessage] = useState("");
  const [openMessage, setOpenMessage] = useState(false);
  const [severity, setSeverity] = useState("");

  const createMessage = (message, openMessage, severity) => {
    setMessage(message);
    setOpenMessage(openMessage);
    setSeverity(severity);
  };

  const [openAdvancedFilter, setOpenAdvancedFilter] = useState(false);

  const theme = useTheme();
  return (
    <div style={{ background: theme.background.base, minHeight: "850px" }}>
      <div
        className="flex justify-between items-center py-[20px] pl-[60px] pr-[20px] fixed w-full z-50"
        style={{
          background: theme.background.header,
          color: theme.color.text1,
        }}
      >
        <div className="font-bold text-[28px] leading-[29px]  ">
          Văn bản nội bộ
        </div>
        <span
          className="w-5 cursor-pointer"
          onClick={() => {
            setOpenAdvancedFilter(true);
          }}
        >
          <Filter />
        </span>
      </div>
      <MainLayout initialValue={2}>
        <div className="px-2 pt-20">
          <DocumentPage valueInit={1} />
          <InternalDocumentOutgoing
            createMessage={createMessage}
            openAdvancedFilter={openAdvancedFilter}
            setOpenAdvancedFilter={setOpenAdvancedFilter}
          />
        </div>
        <Message
          message={message}
          openMessage={openMessage}
          severity={severity}
          closeMessage={() => {
            setOpenMessage(false);
          }}
        />
      </MainLayout>
    </div>
  );
};

export default memo(inject("aclStore")(observer(InternalDocumentOutoingPage)));
